<template>
    <div id="odmietnut_modal" class="modal">
         <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x" crossorigin="anonymous">
        <div class="modal-content p-2">
            <div class="row">
                <div class="col-lg-12 pb-0">
                    <div class="d-flex justify-content-center align-items-center">
                        <div class="formular_nadpis p-0">
                            {{ $t('suhlasite_n_nadpis') }}</div>
                        <span class="btn_close" id="close_odmietnut">&times;</span>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10 pt-0">
                        <div class="form-floating">
                            <input 
                                v-model="ponuka.firma"
                                type="text" 
                                class="form-control" 
                                id="floatingNazov" 
                                placeholder="Názov firmy">
                            <label for="floatingNazov">
                                {{ $t('suhlasite_n_nazov') }}</label>
                        </div>
                        <div class="form-floating" :style="errors.meno ? 'border: 1px solid #F93C34' : ''">
                            <input 
                                v-model="ponuka.meno"
                                type="text" 
                                class="form-control" 
                                id="floatingNazov" 
                                placeholder="Meno a priezvisko">
                            <label for="floatingNazov">
                                {{ $t('suhlasite_n_meno') }}<span class="text-danger">*</span></label>
                        </div>
                        <div class="form-floating" :style="errors.email ? 'border: 1px solid #F93C34' : ''">
                            <input 
                                v-model="ponuka.email"
                                type="email" 
                                class="form-control" 
                                id="floatingNazov" 
                                placeholder="Email">
                            <label for="floatingNazov">{{ $t('suhlasite_n_email') }}<span class="text-danger">*</span></label>
                        </div>
                        <div class="form-floating textarea">
                            <textarea 
                                v-model="ponuka.text" 
                                class="form-control" 
                                placeholder="Text" 
                                id="floatingTextarea2">
                            </textarea>
                            <label for="floatingTextarea2">{{ $t('suhlasite_n_text') }}</label>
                        </div>
                        <div class="formular_btn pt-2">
                            <div @click="submit" class="ulozit" 
                                :style=" 'border: 1px solid'  + color+ '; '+ 
                                        'color: ' + color+';'">
                                <span v-show="!saved">
                                    {{$t('suhlasite_n_odoslat')}}
                                </span>
                                <div v-show="saved" class="lds-ellipsis green">
                                    <div :style="'background:'+ color+';'"></div>
                                    <div :style="'background:'+ color+';'"></div>
                                    <div :style="'background:'+ color+';'"></div>
                                    <div :style="'background:'+ color+';'"></div>
                                </div>
                            </div>
                        </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['offer_id', 'color'],
        data() {
            return {
                saved: false,
                ponuka: {
                    confirmed: 0,
                    send: 1,
                    firma: "",
                    meno: "",
                    email: "",
                    ico: "",
                    dic: "",
                    icdph: "",
                    text: ""
                },
                errors: {}
            }
        },
        methods: {
            getErrors(){
                this.errors = {}
                if(this.ponuka.meno == "")
                    this.errors['meno'] = true

                if(this.ponuka.email == "")
                    this.errors['email'] = true
            },
            submit() {
                this.getErrors()
                if(Object.keys(this.errors).length === 0){
                    this.ponuka['offer_id'] = this.offer_id
                    this.saved = true;
                    axios.post('/api/poPonuka', this.ponuka).then(response => {
                        this.saved = false;
                        window.location.reload();
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
*{font-family: 'Montserrat';}
.modal {
    display: none;
    position: fixed;
    z-index: 15;
    padding-top: 100px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
}
.modal-content {
    background-color: #fefefe;
    width: 600px !important;
    height: auto;
    border-radius: 15px;
    box-shadow: 0 34px 74px 0 rgba(0, 0, 0, 0.1);
    margin: auto;
    padding: 20px;
    position: relative;
}
.ulozit {
    margin: 15px auto 0 auto;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100px;
    height: 50px;
    box-sizing: border-box;
    border-radius: 4px;  
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
}
.formular_popis{
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    line-height: 150%;
    text-align: center;
    color: #212541;
    width: 90%;
    margin: 15px auto 0px auto;
}
.btn_close {
    position: absolute;
    right: 7px;
    top: -5px;
    font-size: 30px;
    cursor: pointer;
}
.textarea>.form-control:focus{
    padding: 0 0 0 15px !important;
}
.textarea{
    border: 1px solid #DDE3E8;
    border-radius: 0;
    textarea{
        border: none !important;
        border-top: 25px solid transparent !important;
        padding-top: 0;
        width: 100%;
        height: 120px;
        background: #FFFFFF;
        box-sizing: border-box;
    }
}
textarea, input{
    font-family: Roboto, 'Montserrat';
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;

    color: #212541;

    border: 1px solid #DDE3E8;
    border-radius: 0;
}   
.flex-inputs{
    display:flex;
    width:100%;
    .input_one{
        width:55%;
        margin-left:auto;
    }
    .input_two{
        width:40%;
    }
}
.modal-content{
    border: none;
}
.form-floating{
    position: relative;
    .counter{
        position: absolute;
        right: 5px;
        bottom: 5px;
        font-size: 10px;
        font-weight: 300;
        color: #9598A7;
    }
}
.form-floating{
    margin-top: 15px;
}
.form-floating > label{
    padding: 22px 13px;
}
.form-floating > label, .float-container label{
    font-family: Roboto, 'Montserrat';
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #9598A7;
}
.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(24px, 0);
    }
}
</style>